import script from "./MainHeaderMenuPhone.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainHeaderMenuPhone.vue?vue&type=script&lang=ts&setup=true"

import "./MainHeaderMenuPhone.vue?vue&type=style&index=0&id=6046b0a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6046b0a2"]])

export default __exports__